import React from 'react';
import { EditItemProps } from '../../../toolympus/api/useNewItem';
import { DiscountCode, DiscountCodeSchema } from './useDiscountCodes';
import { FormGrid, SimpleDialog } from '../../../toolympus/components/primitives';
import { FormControlsForFields } from '../../../toolympus/components/schemed';

interface Props {
  data: EditItemProps<DiscountCode>;
}

export const EditDiscountCodeDialog = (props: Props) => {
  const { data } = props;
  return (
    <SimpleDialog
      dialogTitle="Discount code"
      noFullscreen
      {...data.dialog}
      save={() => data.save()}>
      <FormGrid noMargin columns="1fr">
        <FormControlsForFields
          data={data.item}
          onChange={(o,c) => data.update(c)}
          schema={DiscountCodeSchema}
          fields={[
            ["code", { disabled: true }],
            ["discount_amount"],
            ["is_active"],
            ["is_multiusage"],
          ]}
          />
      </FormGrid>
    </SimpleDialog>
  );
}
